import { render } from "./MusterilerDetayView.vue?vue&type=template&id=2870ce84&scoped=true"
import script from "./MusterilerDetayView.vue?vue&type=script&lang=js"
export * from "./MusterilerDetayView.vue?vue&type=script&lang=js"

import "./MusterilerDetayView.vue?vue&type=style&index=0&id=2870ce84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2870ce84"]])

export default __exports__